// extracted by mini-css-extract-plugin
export default {"follow":"entity-selection_follow__Pn6lx"};